import "~/misc/common";
import { p } from "~/misc/common";
import L from "~/misc/2d/leaflet";
import { Context2d } from "~/types/map";

export function initPosition(map: Context2d) {
  console.log('initPosition');
  if (!("geolocation" in navigator)) {
    $('#btnPosition').hide();
    p('Geolocation not supported in this browser');
    return;
  }

  let watchId: number | null = null;
  let tracking = false;
  let firstLock = false;

  // Custom Bootstrap icon marker
  const customIcon = L.divIcon({
    className: 'position-marker',
    html: '<i class="bi bi-crosshair"></i>', // Bootstrap Icon
    iconAnchor: [0, 0] // Centers the icon
  });

  const marker = L.marker([0, 0], { icon: customIcon });
  const circle = L.circle([0, 0], {
    radius: 0,
    weight: 1,
    color: 'yellow',
    fillOpacity: 0.5,
    interactive: false
  });
  //.bindPopup("Custom Crosshair Marker");

  $('#btnPosition').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).blur();
    refreshLayers();
  });

  function refreshLayers() {
    if ($('#btnPosition').hasClass('active')) {
      $('#btnPosition').css('background-color', 'lightgreen');
      firstLock = true;
      startTracking();
    } else {
      $('#btnPosition').css('background-color', 'white');
      marker.remove();
      circle.remove();
      stopTracking();
    }
  }

  function onPosition(position: GeolocationPosition) {
    const lat = position.coords.latitude;
    const lon = position.coords.longitude;
    const acc = position.coords.accuracy || 200;
    p([lat, lon, acc]);
    marker.setLatLng([lat, lon]);
    marker.addTo(map);
    circle.setLatLng([lat, lon]);
    circle.setRadius(acc);
    fadeOutCircle(circle);
    circle.addTo(map);
    if (firstLock) {
      map.flyTo(marker.getLatLng(), Math.max(map.getZoom(), 16), {
        duration: 0.5
      });
      firstLock = false;
    }
  }

  let interval: number | null = null;
  function fadeOutCircle(circle: L.Circle, duration = 5000) {
    let opacity = 0.5;  // Start opacity
    const minOpacity = 0.1; // Stop opacity
    const step = 50;       // Interval step (ms)
    const decrement = step / duration * (opacity - minOpacity); // How much opacity to decrease per step

    if (interval) clearInterval(interval);
    interval = setInterval(() => {
      opacity -= decrement;
      if (opacity <= minOpacity) {
        if (interval) clearInterval(interval);
        //map.removeLayer(circle);  // Optionally remove the circle
      } else {
        circle.setStyle({ fillOpacity: opacity, opacity: opacity });
      }
    }, step);
  }


  //map.tree.element.on("select_node.jstree", function (e, d) {
  //	if (d.event && d.node.id == 'position') {
  //		map.panTo(marker.getLatLng())
  //	}
  //});

  function startTracking() {
    if (tracking) return;
    watchId = navigator.geolocation.watchPosition(
      function (position) {
        onPosition(position);
      },
      function (error) {
        p("Error getting location:");
        p(error);
        alert('Helyadatok nem érhetők el');
        $('#btnPosition').toggleClass('active');
        refreshLayers();
      },
      { enableHighAccuracy: true, maximumAge: 0 }
    );
    tracking = true;
  }

  function stopTracking() {
    if (watchId !== null) {
      navigator.geolocation.clearWatch(watchId);
      watchId = null;
      tracking = false;
    }
  }
}
